"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TraditionalvRothPageOne;
var _react = _interopRequireDefault(require("react"));
var _formik = require("formik");
var _TraditionalvRothFormControl = require("./TraditionalvRothFormControl");
var _TraditionalvRothPopovers = require("./TraditionalvRothPopovers");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function TraditionalvRothPageOne() {
  var {
    errors,
    touched,
    values,
    setFieldValue
  } = (0, _formik.useFormikContext)();
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_TraditionalvRothFormControl.CurrentAge, {
    errors: errors,
    touched: touched,
    values: values,
    setFieldValue: setFieldValue
  }), /*#__PURE__*/_react.default.createElement(_TraditionalvRothFormControl.State, {
    errors: errors,
    touched: touched,
    values: values,
    setFieldValue: setFieldValue
  }), /*#__PURE__*/_react.default.createElement(_TraditionalvRothFormControl.RetirementAge, {
    errors: errors,
    touched: touched,
    values: values,
    setFieldValue: setFieldValue
  }), /*#__PURE__*/_react.default.createElement(_TraditionalvRothPopovers.CustomEarlyWithdrawalPopoverModal, null), /*#__PURE__*/_react.default.createElement(_TraditionalvRothFormControl.WithdrawalAge, {
    errors: errors,
    touched: touched,
    values: values,
    setFieldValue: setFieldValue
  }), /*#__PURE__*/_react.default.createElement(_TraditionalvRothFormControl.FilingStatus, {
    errors: errors,
    touched: touched,
    values: values,
    setFieldValue: setFieldValue
  }), /*#__PURE__*/_react.default.createElement(_TraditionalvRothFormControl.Salary, {
    errors: errors,
    touched: touched,
    values: values,
    setFieldValue: setFieldValue
  }), /*#__PURE__*/_react.default.createElement(_TraditionalvRothPopovers.TaxRateChartPopoverModal, null), /*#__PURE__*/_react.default.createElement(_TraditionalvRothFormControl.TaxRate, {
    errors: errors,
    touched: touched,
    values: values,
    setFieldValue: setFieldValue
  }));
}